import Representation2d from './representation2d/Representation2d';
import ShapeRepresentation2d from './representation2d/ShapeRepresentation2d';
import SvgRepresentation2d from './representation2d/SvgRepresentation2d';
import ShapeTypeEnum from './representation2d/ShapeTypeEnum';

import Representation3d from './representation3d/Representation3d';
import ExtrudedAreaSolid from './representation3d/ExtrudedAreaSolid';
import TriangleMesh from './representation3d/TriangleMesh';
import FbxAsset from './representation3d/FbxAsset';
import Representation3dTypeEnum from './representation3d/Representation3dTypeEnum';

export default class RepresentationFactory {
    public static createRepresentation2d(type: string, data: any): Representation2d {
        
        let result: Representation2d;
        
        switch (type) {
            case ShapeTypeEnum.Shape:
                result = ShapeRepresentation2d.fromJSON(data);
                break;

            case ShapeTypeEnum.SvgSymbol:
                result = SvgRepresentation2d.fromJSON(data);
                break;
            
            default:
                throw new Error('Unknown representation type');
        }
        
        return result;
    }

    public static createRepresentation3d(type: string, data: any): Representation3d {
        
        let result: Representation3d;
        
        switch (type) {
            case Representation3dTypeEnum.ExtrudedAreaSolid:
                result = ExtrudedAreaSolid.fromJSON(data);
                break;

            case Representation3dTypeEnum.TriangleMesh:
                result = TriangleMesh.fromJSON(data);
                break;
            
            case Representation3dTypeEnum.FbxAsset:
                result = FbxAsset.fromJSON(data);
                break;
            
            default:
                throw new Error('Unknown representation type');
        }

        
        return result;
    }
}


